import { render, staticRenderFns } from "./IssuesTypesFormEdit.vue?vue&type=template&id=ec29078e"
import script from "./IssuesTypesFormEdit.vue?vue&type=script&lang=js"
export * from "./IssuesTypesFormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports